export const translations = {
  en: {
    nav: {
      home: 'Home',
      artists: 'Artists',
      exhibitions: 'Exhibitions',
      artFairs: 'Art Fairs',
      shop: 'Shop',
      about: 'About',
      team: 'Team',
      contact: 'Contact',
      dropshop: 'Dropshop',
    },
    hero: {
      subtitle: 'Fine Art Photography Gallery',
      explore: 'Explore',
    },
    shop: {
      title: 'Shop',
      comingSoonLabel: 'Online Shop',
      comingSoonTitle: 'Coming\nSoon',
      comingSoonSubtitle: 'Our curated collection of fine art photography is being prepared. A timeless selection — soon to be unveiled.',
      searchPlaceholder: 'Search artworks...',
      filters: 'Filters',
      categories: 'Categories',
      size: 'Size',
      price: 'Price',
      rarity: 'Rarity',
      sort: 'Sort',
      sortOptions: {
        recommended: 'Recommended',
        priceAsc: 'Price: Low to High',
        priceDesc: 'Price: High to Low',
        newest: 'Newest',
        popular: 'Most Popular',
      },
      addToCart: 'Add to Cart',
      addedToCart: 'Added to cart',
      currency: 'Currency',
      noResults: 'No artworks found matching your criteria',
      all: 'All',
    },
    artwork: {
      by: 'by',
      medium: 'Medium',
      dimensions: 'Dimensions',
      year: 'Year',
      edition: 'Edition',
      rarity: 'Rarity',
      inStock: 'Available',
      outOfStock: 'Out of stock',
      soldOut: 'Sold',
      frame: 'Frame',
      unframed: 'Unframed',
      blackFrame: 'Black Frame',
      whiteFrame: 'White Frame',
      customFrame: 'Custom Frame (Contact Us)',
      quantity: 'Quantity',
      total: 'Total',
      viewInRoom: 'View in Room',
      aboutWork: 'About the Work',
      aboutArtist: 'About the Artist',
      shipping: 'Shipping & Returns',
      shippingInfo: 'Worldwide shipping within 5-7 business days',
      returnInfo: '30-day return policy',
      authentication: 'Certificate of authenticity included',
      similarWorks: 'You May Also Like',
      tags: 'Tags',
      backToShop: 'Back to Shop',
      details: 'Details',
      sizeLabel: 'Size',
      selectSize: 'Select Size',
      share: 'Share',
      linkCopied: 'Link copied to clipboard',
    },
    artists: {
      title: 'Artists',
      seeMore: 'See More',
      works: 'works',
    },
    exhibitions: {
      title: 'Exhibitions',
      current: 'Current',
      upcoming: 'Upcoming',
      past: 'Past',
      archive: 'Archive',
      all: 'All',
      viewExhibition: 'View Exhibition',
      gallery: 'Gallery',
      aboutExhibition: 'About the Exhibition',
      aboutArtist: 'About the Artist',
      participatingArtists: 'Participating Artists',
    },
    artFairs: {
      title: 'Art Fairs & Auctions',
      viewFair: 'View Art Fair',
      gallery: 'Gallery',
      aboutFair: 'About the Fair',
      featuredWorks: 'Featured Works',
    },
    team: {
      title: 'Our Team',
    },
    cart: {
      title: 'Cart',
      empty: 'Your cart is empty',
      subtotal: 'Subtotal',
      checkout: 'Proceed to Checkout',
      remove: 'Remove',
    },
    checkout: {
      title: 'Checkout',
      orderSummary: 'Order Summary',
      shippingDetails: 'Shipping Details',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      address: 'Address',
      address2: 'Apartment, suite, floor (optional)',
      state: 'State / Region',
      stateUs: 'State',
      city: 'City',
      country: 'Country',
      postalCode: 'Postal Code',
      paymentMethod: 'Payment Method',
      cardNumber: 'Card Number',
      expiry: 'Expiry',
      cvv: 'CVV',
      placeOrder: 'Place Order',
      shipping: 'Shipping',
      tax: 'Tax',
      total: 'Total',
      free: 'Free',
      securePayment: 'Secure Payment',
      orderProtection: 'Your order is protected by SSL encryption',
      backToCart: 'Back to Cart',
      items: 'items',
      deliveryMethod: 'Delivery Method',
      pickup: 'Pickup from Gallery',
      delivery: 'Delivery',
      shippingAddress: 'Shipping Address',
      billingAddress: 'Billing Address',
      sameAsShipping: 'Same as shipping address',
      phoneRequired: 'Phone number is required for delivery',
      fixErrors: 'Please fill in the highlighted fields',
    },
    form: {
      optional: 'optional',
      required: 'Required',
      requiredNote: 'required field',
      requiredField: 'This field is required',
      emailLocked: 'Contact us to change your email — it is what you sign in with.',
    },
    contact: {
      customFrameSubject: 'Custom Frame Inquiry',
      name: 'Name',
      email: 'Email',
      subject: 'Subject',
      message: 'Message',
      send: 'Send Message',
      rateLimited: 'Please wait before sending another message',
      loginRequired: 'Account Required',
      loginRequiredDesc: 'Create an account or sign in to send us a message. This helps us respond to you directly through your personal inbox.',
      signInToMessage: 'Sign In',
      createAccount: 'Create Account',
      whyRegister: 'Why register?',
      whyRegisterReasons: [
        'Get replies directly in your inbox',
        'Track all your conversations',
        'Faster response from our team',
      ],
    },
    giftCard: {
      title: 'Gift Cards',
      selectAmount: 'Select Amount',
      description: 'The perfect gift for art lovers',
      addToCart: 'Add Gift Card to Cart',
    },
    dropshop: {
      title: 'Dropshop',
      subtitle: 'Exclusive Limited Collections',
      explore: 'Explore Collection',
      relatedArtworks: 'Artworks',
      releaseDate: 'Release Date',
      limitedEdition: 'Limited Edition',
      noCollections: 'No collections available',
      collectionStory: 'Collection Story',
      buyThisPrint: 'Buy This Print',
      availablePrints: 'Available Prints',
      artistSpotlight: 'The Artist',
      viewAllWorks: 'View All Works',
      scrollToExplore: 'Scroll to Explore',
      watchVideo: 'Watch Video',
      comingSoonSubtitle: 'The next drop is being prepared. Limited collections, released one at a time.',
    },
    notifications: {
      title: 'Notifications',
      markAllRead: 'Mark all read',
      noNotifications: 'No notifications',
      trackingAdded: 'Tracking info added to order',
      statusChanged: 'Order status changed',
      justNow: 'Just now',
      minutesAgo: 'min ago',
      hoursAgo: 'hr ago',
      daysAgo: 'd ago',
    },
    reviews: {
      title: 'Reviews',
      writeReview: 'Write a Review',
      noReviews: 'No reviews yet',
      beFirst: 'Be the first to review this artwork',
      rating: 'Rating',
      comment: 'Your review',
      submit: 'Submit Review',
      submitted: 'Review submitted successfully',
      loginToReview: 'Log in to write a review',
      allReviews: 'All Reviews',
      hidden: 'Hidden',
      visible: 'Visible',
      deleteConfirm: 'Delete this review?',
      deleted: 'Review deleted',
      updated: 'Review updated',
      addReview: 'Add Review',
      editReview: 'Edit Review',
      author: 'Author',
      artwork: 'Artwork',
      status: 'Status',
      date: 'Date',
      reviewCount: 'reviews',
    },
    inbox: {
      title: 'Inbox',
      noMessages: 'No messages yet',
      messageSent: 'Message sent successfully',
      reply: 'Reply',
      replyPlaceholder: 'Type your reply...',
      send: 'Send',
      markResolved: 'Mark Resolved',
      reopen: 'Reopen',
      open: 'Open',
      resolved: 'Resolved',
      from: 'From',
      subject: 'Subject',
      messages: 'Messages',
      lastActivity: 'Last Activity',
      allMessages: 'All Messages',
      yourMessages: 'Your Messages',
      noConversations: 'No conversations yet',
      messageReceived: 'New message received',
      adminReplied: 'Admin replied to your message',
      contactSuccess: "Your message has been sent. We'll get back to you soon!",
    },
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      loginButton: 'Sign In',
      registerButton: 'Create Account',
      noAccount: "Don't have an account?",
      hasAccount: 'Already have an account?',
      orContinueAsGuest: 'Or continue as guest',
      passwordMinLength: 'Password must be at least 8 characters, with one number and one symbol',
      passwordsDontMatch: 'Passwords do not match',
      invalidEmail: 'Invalid email address',
      emailInUse: 'Email is already registered',
      invalidCredentials: 'Invalid email or password',
      loginToCheckout: 'Sign in to continue checkout',
      registerToCheckout: 'Create an account to place your order',
      birthDate: 'Date of Birth',
      day: 'Day',
      month: 'Month',
      year: 'Year',
      optional: 'optional',
      yearsOld: 'years old',
      forgotPassword: 'Forgot Password?',
      forgotPasswordTitle: 'Reset Password',
      forgotPasswordDesc: "Enter your email and we'll send you a reset link",
      resetLinkSent: 'Reset Link Sent!',
      checkEmail: 'Check your email for the password reset link. The link will expire in 1 hour.',
      noAccountFound: 'No account found with this email',
      newPassword: 'New Password',
      resetPasswordButton: 'Reset Password',
      passwordResetSuccess: 'Password Reset Successfully!',
      invalidResetLink: 'Invalid or Expired Reset Link',
      backToLogin: 'Back to Login',
      goToLogin: 'Go to Login',
    },
    profile: {
      title: 'My Profile',
      orders: 'Orders',
      wishlist: 'Wishlist',
      account: 'Account',
      settings: 'Settings',
      editProfile: 'Edit Profile',
      changePassword: 'Change Password',
      oldPassword: 'Current Password',
      newPassword: 'New Password',
      confirmNewPassword: 'Confirm New Password',
      saveChanges: 'Save Changes',
      noOrders: 'No orders yet',
      emptyWishlist: 'Your wishlist is empty',
      orderDate: 'Date',
      orderStatus: 'Status',
      orderTotal: 'Total',
      passwordChanged: 'Password changed successfully',
      profileUpdated: 'Profile updated successfully',
      wrongPassword: 'Current password is incorrect',
      loginToWishlist: 'Sign in to save to wishlist',
      shippingAddress: 'Shipping Address',
      billingAddress: 'Billing Address',
      addressOptionalHint: 'You can leave this blank — you will be asked for it at checkout.',
    },
    settings: {
      currency: 'Currency',
      language: 'Language',
      theme: 'Theme',
      lightMode: 'Light',
      darkMode: 'Dark',
      refreshRate: 'Refresh Rate',
      rateUpdated: 'Exchange rate updated',
      nbgRate: 'NBG Rate',
      nbgSource: 'National Bank of Georgia',
    },
    newsletter: {
      title: 'Stay in the Loop',
      subtitle: 'Get notified about new exhibitions, exclusive drops, and gallery events.',
      placeholder: 'Enter your email',
      subscribe: 'Subscribe',
      success: 'Welcome aboard! You\'re now subscribed.',
      alreadySubscribed: 'You\'re already subscribed!',
      invalidEmail: 'Please enter a valid email',
    },
    legal: {
      cookiePolicy: 'Cookie Policy',
      privacyPolicy: 'Privacy Policy',
      termsConditions: 'Terms & Conditions',
      lastUpdated: 'Last Updated: January 2025',
      terms: {
        intro: 'These Terms and Conditions govern your use of the Gallery Fotoatelier website and services. By accessing our website, you agree to comply with these terms.',
        useTitle: 'Use of Website',
        useText: 'You may use our website for lawful purposes only. You agree not to use the website in any way that could damage, disable, or impair the website or interfere with any other party\'s use. Unauthorized use of this website may give rise to a claim for damages and/or be a criminal offense.',
        purchaseTitle: 'Purchases & Orders',
        purchaseText: 'All purchases through our gallery are subject to availability. Prices are displayed in GEL and USD. We reserve the right to refuse any order. Payment must be completed before artwork delivery. All sales are considered final unless otherwise specified for a particular item.',
        ipTitle: 'Intellectual Property',
        ipText: 'All content on this website, including images, text, designs, and logos, is the property of Gallery Fotoatelier or its artists and is protected by copyright laws. You may not reproduce, distribute, or use any content without prior written permission.',
        liabilityTitle: 'Limitation of Liability',
        liabilityText: 'Gallery Fotoatelier shall not be liable for any indirect, incidental, or consequential damages arising from the use of our website or services. We make every effort to ensure the accuracy of information on our website but cannot guarantee it is error-free.',
        changesTitle: 'Changes to Terms',
        changesText: 'We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on this page. Continued use of the website after changes constitutes acceptance of the new terms.',
        contactTitle: 'Contact Us',
        contactText: 'If you have questions about these Terms and Conditions, please contact us at info@fotoatelier.ge or visit Gallery Fotoatelier at 12 Rustaveli Avenue, Tbilisi, Georgia.',
      },
      cookie: {
        intro: 'This Cookie Policy explains how Gallery Fotoatelier uses cookies and similar technologies when you visit our website.',
        whatTitle: 'What Are Cookies',
        whatText: 'Cookies are small text files stored on your device when you visit a website. They help the site remember your preferences and improve your browsing experience. Cookies can be "session" cookies, which are deleted when you close your browser, or "persistent" cookies, which remain until they expire or you delete them.',
        howTitle: 'How We Use Cookies',
        howText: 'We use cookies to remember your language preference (English or Georgian), store your theme choice (light or dark mode), maintain your shopping cart contents, keep you signed in to your account, and understand how visitors interact with our website to improve our services.',
        typesTitle: 'Types of Cookies We Use',
        typesText: 'Essential cookies are necessary for the website to function properly, including authentication and cart functionality. Preference cookies remember your settings such as language and display preferences. Analytics cookies help us understand how visitors use our site so we can improve the experience.',
        managingTitle: 'Managing Cookies',
        managingText: 'You can control and manage cookies through your browser settings. Most browsers allow you to refuse or accept cookies, delete existing cookies, and set preferences for certain websites. Please note that disabling essential cookies may affect the functionality of our website.',
        contactTitle: 'Questions',
        contactText: 'If you have questions about our use of cookies, please contact us at info@fotoatelier.ge or visit our gallery at 12 Rustaveli Avenue, Tbilisi.',
      },
      privacy: {
        intro: 'Gallery Fotoatelier is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information.',
        collectTitle: 'Information We Collect',
        collectText: 'We collect information you provide directly: name, email address, phone number, and shipping address when you create an account or place an order. We also collect browsing data such as pages visited, language preference, and device information to improve our services.',
        useTitle: 'How We Use Your Information',
        useText: 'We use your information to process and deliver your orders, communicate about your purchases and account, send newsletters if you have subscribed, improve our website and services, and respond to your inquiries through our contact form.',
        protectionTitle: 'Data Protection',
        protectionText: 'We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. Your account is protected by a password, and we recommend choosing a strong, unique password.',
        rightsTitle: 'Your Rights',
        rightsText: 'You have the right to access, correct, or delete your personal data. You can update your profile information at any time through your account settings. To request data deletion, please contact us directly. You may also unsubscribe from our newsletter at any time.',
        contactTitle: 'Contact Us',
        contactText: 'For any privacy-related questions or requests, please reach out to us at info@fotoatelier.ge or visit Gallery Fotoatelier at 12 Rustaveli Avenue, Tbilisi, Georgia.',
      },
    },
    news: {
      title: 'Press & News',
      subtitle: 'Latest from Gallery Fotoatelier',
      readMore: 'Read More',
      backToNews: 'Back to News',
      noArticles: 'No articles yet',
      featured: 'Featured',
      publishedOn: 'Published',
    },
    common: {
      loading: 'Loading...',
      error: 'Something went wrong',
      retry: 'Retry',
      currency: {
        USD: '$',
        GEL: 'GEL',
      },
    },
  },
  ka: {
    nav: {
      home: 'მთავარი',
      artists: 'ხელოვანები',
      exhibitions: 'გამოფენები',
      artFairs: 'არტ ბაზრობები',
      shop: 'მაღაზია',
      about: 'ჩვენს შესახებ',
      team: 'გუნდი',
      contact: 'კონტაქტი',
      dropshop: 'დროპშოპი',
    },
    hero: {
      subtitle: 'სახელოვნებო ფოტოგალერეა',
      explore: 'აღმოაჩინე',
    },
    shop: {
      title: 'მაღაზია',
      comingSoonLabel: 'ონლაინ მაღაზია',
      comingSoonTitle: 'Coming\nSoon',
      comingSoonSubtitle: 'ჩვენი შერჩეული ფოტოგრაფიის კოლექცია მზადდება. მალე გაიხსნება.',
      searchPlaceholder: 'ნამუშევრების ძებნა...',
      filters: 'ფილტრები',
      categories: 'კატეგორიები',
      size: 'ზომა',
      price: 'ფასი',
      rarity: 'იშვიათობა',
      sort: 'დალაგება',
      sortOptions: {
        recommended: 'რეკომენდებული',
        priceAsc: 'ფასი: დაბალიდან მაღლისკენ',
        priceDesc: 'ფასი: მაღალიდან დაბლისკენ',
        newest: 'უახლესი',
        popular: 'პოპულარული',
      },
      addToCart: 'კალათაში დამატება',
      addedToCart: 'დამატებულია კალათაში',
      currency: 'ვალუტა',
      noResults: 'ნამუშევრები ვერ მოიძებნა',
      all: 'ყველა',
    },
    artwork: {
      by: '-',
      medium: 'მედიუმი',
      dimensions: 'ზომები',
      year: 'წელი',
      edition: 'ტირაჟი',
      rarity: 'იშვიათობა',
      inStock: 'ხელმისაწვდომი',
      outOfStock: 'ამოწურულია',
      soldOut: 'გაყიდული',
      frame: 'ჩარჩო',
      unframed: 'ჩარჩოს გარეშე',
      blackFrame: 'შავი ჩარჩო',
      whiteFrame: 'თეთრი ჩარჩო',
      customFrame: 'ინდივიდუალური ჩარჩო (დაგვიკავშირდით)',
      quantity: 'რაოდენობა',
      total: 'ჯამი',
      viewInRoom: 'ინტერიერში ნახვა',
      aboutWork: 'ნამუშევრის შესახებ',
      aboutArtist: 'ხელოვანის შესახებ',
      shipping: 'მიტანა და დაბრუნება',
      shippingInfo: 'მსოფლიო მასშტაბით მიტანა 5-7 სამუშაო დღეში',
      returnInfo: '30 დღიანი დაბრუნების პოლიტიკა',
      authentication: 'ავთენტურობის სერტიფიკატი',
      similarWorks: 'ასევე მოგეწონებათ',
      tags: 'თეგები',
      backToShop: 'მაღაზიაში დაბრუნება',
      details: 'დეტალები',
      sizeLabel: 'ზომა',
      selectSize: 'აირჩიეთ ზომა',
      share: 'გაზიარება',
      linkCopied: 'ბმული დაკოპირდა',
    },
    artists: {
      title: 'ხელოვანები',
      seeMore: 'მეტის ნახვა',
      works: 'ნამუშევრები',
    },
    exhibitions: {
      title: 'გამოფენები',
      current: 'მიმდინარე',
      upcoming: 'მომავალი',
      past: 'წარსული',
      archive: 'არქივი',
      all: 'ყველა',
      viewExhibition: 'გამოფენის ნახვა',
      gallery: 'გალერეა',
      aboutExhibition: 'გამოფენის შესახებ',
      aboutArtist: 'ხელოვანის შესახებ',
      participatingArtists: 'მონაწილე ხელოვანები',
    },
    artFairs: {
      title: 'არტ ბაზრობები და აუქციონები',
      viewFair: 'არტ ბაზრობის ნახვა',
      gallery: 'გალერეა',
      aboutFair: 'ბაზრობის შესახებ',
      featuredWorks: 'წარმოდგენილი ნამუშევრები',
    },
    team: {
      title: 'ჩვენი გუნდი',
    },
    cart: {
      title: 'კალათა',
      empty: 'კალათა ცარიელია',
      subtotal: 'ქვეჯამი',
      checkout: 'შეკვეთის გაფორმება',
      remove: 'წაშლა',
    },
    checkout: {
      title: 'შეკვეთის გაფორმება',
      orderSummary: 'შეკვეთის შეჯამება',
      shippingDetails: 'მიწოდების დეტალები',
      firstName: 'სახელი',
      lastName: 'გვარი',
      email: 'ელ. ფოსტა',
      phone: 'ტელეფონი',
      address: 'მისამართი',
      address2: 'ბინა, სართული, ოფისი (არასავალდებულო)',
      state: 'შტატი / რეგიონი',
      stateUs: 'შტატი',
      city: 'ქალაქი',
      country: 'ქვეყანა',
      postalCode: 'საფოსტო კოდი',
      paymentMethod: 'გადახდის მეთოდი',
      cardNumber: 'ბარათის ნომერი',
      expiry: 'ვადა',
      cvv: 'CVV',
      placeOrder: 'შეკვეთის განთავსება',
      shipping: 'მიტანა',
      tax: 'გადასახადი',
      total: 'ჯამი',
      free: 'უფასო',
      securePayment: 'უსაფრთხო გადახდა',
      orderProtection: 'თქვენი შეკვეთა დაცულია SSL დაშიფვრით',
      backToCart: 'კალათაში დაბრუნება',
      items: 'ნივთი',
      deliveryMethod: 'მიტანის მეთოდი',
      pickup: 'თვითგატანა გალერეიდან',
      delivery: 'მიტანა',
      shippingAddress: 'მიტანის მისამართი',
      billingAddress: 'გადახდის მისამართი',
      sameAsShipping: 'იგივე რაც მიტანის მისამართი',
      phoneRequired: 'ტელეფონის ნომერი სავალდებულოა მიტანისთვის',
      fixErrors: 'გთხოვთ შეავსოთ მონიშნული ველები',
    },
    form: {
      optional: 'არასავალდებულო',
      required: 'სავალდებულო',
      requiredNote: 'სავალდებულო ველი',
      requiredField: 'ეს ველი სავალდებულოა',
      emailLocked: 'ელფოსტის შესაცვლელად დაგვიკავშირდით — ამ მისამართით შედიხართ სისტემაში.',
    },
    contact: {
      customFrameSubject: 'ინდივიდუალური ჩარჩოს მოთხოვნა',
      name: 'სახელი',
      email: 'ელ. ფოსტა',
      subject: 'თემა',
      message: 'შეტყობინება',
      send: 'შეტყობინების გაგზავნა',
      rateLimited: 'გთხოვთ, დაელოდოთ სხვა შეტყობინების გაგზავნამდე',
      loginRequired: 'საჭიროა ანგარიში',
      loginRequiredDesc: 'შექმენით ანგარიში ან შედით სისტემაში შეტყობინების გასაგზავნად. ეს გვეხმარება პირდაპირ თქვენს პირად შეტყობინებებში გიპასუხოთ.',
      signInToMessage: 'შესვლა',
      createAccount: 'ანგარიშის შექმნა',
      whyRegister: 'რატომ რეგისტრაცია?',
      whyRegisterReasons: [
        'პასუხების მიღება პირად შეტყობინებებში',
        'ყველა საუბრის თვალყურის დევნება',
        'სწრაფი პასუხი ჩვენი გუნდისგან',
      ],
    },
    giftCard: {
      title: 'სასაჩუქრე ბარათები',
      selectAmount: 'აირჩიეთ თანხა',
      description: 'იდეალური საჩუქარი ხელოვნების მოყვარულთათვის',
      addToCart: 'სასაჩუქრე ბარათის დამატება',
    },
    dropshop: {
      title: 'დროპშოპი',
      subtitle: 'ექსკლუზიური ლიმიტირებული კოლექციები',
      explore: 'კოლექციის ნახვა',
      relatedArtworks: 'ნამუშევრები',
      releaseDate: 'გამოშვების თარიღი',
      limitedEdition: 'შეზღუდული ტირაჟი',
      noCollections: 'კოლექციები არ მოიძებნა',
      collectionStory: 'კოლექციის ისტორია',
      buyThisPrint: 'ეს ნაბეჭდი იყიდე',
      availablePrints: 'ხელმისაწვდომი ნაბეჭდები',
      artistSpotlight: 'არტისტი',
      viewAllWorks: 'ყველა ნამუშევრის ნახვა',
      scrollToExplore: 'გადაახვიეთ აღმოსაჩენად',
      watchVideo: 'ვიდეოს ნახვა',
      comingSoonSubtitle: 'შემდეგი კოლექცია მზადდება. ლიმიტირებული გამოშვებები — თითო-თითოდ.',
    },
    notifications: {
      title: 'შეტყობინებები',
      markAllRead: 'ყველას წაკითხულად მონიშვნა',
      noNotifications: 'შეტყობინებები არ არის',
      trackingAdded: 'ტრეკინგ ინფორმაცია დაემატა შეკვეთას',
      statusChanged: 'შეკვეთის სტატუსი შეიცვალა',
      justNow: 'ახლახანს',
      minutesAgo: 'წთ წინ',
      hoursAgo: 'სთ წინ',
      daysAgo: 'დღის წინ',
    },
    reviews: {
      title: 'შეფასებები',
      writeReview: 'დაწერეთ შეფასება',
      noReviews: 'შეფასებები ჯერ არ არის',
      beFirst: 'იყავით პირველი, ვინც შეაფასებს ამ ნამუშევარს',
      rating: 'შეფასება',
      comment: 'თქვენი შეფასება',
      submit: 'გაგზავნა',
      submitted: 'შეფასება წარმატებით გაიგზავნა',
      loginToReview: 'შეფასების დასაწერად გაიარეთ ავტორიზაცია',
      allReviews: 'ყველა შეფასება',
      hidden: 'დამალული',
      visible: 'ხილული',
      deleteConfirm: 'წაშალოთ ეს შეფასება?',
      deleted: 'შეფასება წაშლილია',
      updated: 'შეფასება განახლებულია',
      addReview: 'შეფასების დამატება',
      editReview: 'შეფასების რედაქტირება',
      author: 'ავტორი',
      artwork: 'ნამუშევარი',
      status: 'სტატუსი',
      date: 'თარიღი',
      reviewCount: 'შეფასება',
    },
    inbox: {
      title: 'შეტყობინებები',
      noMessages: 'შეტყობინებები ჯერ არ არის',
      messageSent: 'შეტყობინება წარმატებით გაიგზავნა',
      reply: 'პასუხი',
      replyPlaceholder: 'დაწერეთ პასუხი...',
      send: 'გაგზავნა',
      markResolved: 'მოგვარებულად მონიშვნა',
      reopen: 'ხელახლა გახსნა',
      open: 'ღია',
      resolved: 'მოგვარებული',
      from: 'გამგზავნი',
      subject: 'თემა',
      messages: 'შეტყობინებები',
      lastActivity: 'ბოლო აქტივობა',
      allMessages: 'ყველა შეტყობინება',
      yourMessages: 'თქვენი შეტყობინებები',
      noConversations: 'საუბრები ჯერ არ არის',
      messageReceived: 'ახალი შეტყობინება მიღებულია',
      adminReplied: 'ადმინი გიპასუხათ',
      contactSuccess: 'თქვენი შეტყობინება გაგზავნილია. მალე დაგიკავშირდებით!',
    },
    auth: {
      login: 'შესვლა',
      register: 'რეგისტრაცია',
      email: 'ელ. ფოსტა',
      password: 'პაროლი',
      confirmPassword: 'პაროლის დადასტურება',
      firstName: 'სახელი',
      lastName: 'გვარი',
      phone: 'ტელეფონი',
      loginButton: 'შესვლა',
      registerButton: 'ანგარიშის შექმნა',
      noAccount: 'არ გაქვთ ანგარიში?',
      hasAccount: 'უკვე გაქვთ ანგარიში?',
      orContinueAsGuest: 'ან გააგრძელეთ სტუმრად',
      passwordMinLength: 'პაროლი მინიმუმ 8 სიმბოლო, ერთი ციფრი და ერთი სიმბოლო',
      passwordsDontMatch: 'პაროლები არ ემთხვევა',
      invalidEmail: 'არასწორი ელ. ფოსტის მისამართი',
      emailInUse: 'ელ. ფოსტა უკვე რეგისტრირებულია',
      invalidCredentials: 'არასწორი ელ. ფოსტა ან პაროლი',
      loginToCheckout: 'შესვლა შეკვეთის გასაგრძელებლად',
      registerToCheckout: 'შექმენით ანგარიში შეკვეთის გასაფორმებლად',
      birthDate: 'დაბადების თარიღი',
      day: 'დღე',
      month: 'თვე',
      year: 'წელი',
      optional: 'არასავალდებულო',
      yearsOld: 'წლის',
      forgotPassword: 'დაგავიწყდათ პაროლი?',
      forgotPasswordTitle: 'პაროლის აღდგენა',
      forgotPasswordDesc: 'შეიყვანეთ ელ. ფოსტა და გამოგიგზავნით აღდგენის ბმულს',
      resetLinkSent: 'აღდგენის ბმული გაიგზავნა!',
      checkEmail: 'შეამოწმეთ ელ. ფოსტა პაროლის აღდგენის ბმულისთვის. ბმული მოქმედებს 1 საათის განმავლობაში.',
      noAccountFound: 'ამ ელ. ფოსტით ანგარიში ვერ მოიძებნა',
      newPassword: 'ახალი პაროლი',
      resetPasswordButton: 'პაროლის შეცვლა',
      passwordResetSuccess: 'პაროლი წარმატებით შეიცვალა!',
      invalidResetLink: 'არასწორი ან ვადაგასული აღდგენის ბმული',
      backToLogin: 'შესვლაზე დაბრუნება',
      goToLogin: 'შესვლის გვერდზე გადასვლა',
    },
    profile: {
      title: 'ჩემი პროფილი',
      orders: 'შეკვეთები',
      wishlist: 'სურვილების სია',
      account: 'ანგარიში',
      settings: 'პარამეტრები',
      editProfile: 'პროფილის რედაქტირება',
      changePassword: 'პაროლის შეცვლა',
      oldPassword: 'მიმდინარე პაროლი',
      newPassword: 'ახალი პაროლი',
      confirmNewPassword: 'ახალი პაროლის დადასტურება',
      saveChanges: 'ცვლილებების შენახვა',
      noOrders: 'შეკვეთები ჯერ არ არის',
      emptyWishlist: 'სურვილების სია ცარიელია',
      orderDate: 'თარიღი',
      orderStatus: 'სტატუსი',
      orderTotal: 'ჯამი',
      passwordChanged: 'პაროლი წარმატებით შეიცვალა',
      profileUpdated: 'პროფილი წარმატებით განახლდა',
      wrongPassword: 'მიმდინარე პაროლი არასწორია',
      loginToWishlist: 'შესვლა სურვილების სიაში დასამატებლად',
      shippingAddress: 'მიტანის მისამართი',
      billingAddress: 'გადახდის მისამართი',
      addressOptionalHint: 'შეგიძლია ცარიელი დატოვო — შეკვეთისას მაინც მოგთხოვთ.',
    },
    settings: {
      currency: 'ვალუტა',
      language: 'ენა',
      theme: 'თემა',
      lightMode: 'ნათელი',
      darkMode: 'მუქი',
      refreshRate: 'განახლება',
      rateUpdated: 'კურსი განახლდა',
      nbgRate: 'ეროვნული ბანკის კურსი',
      nbgSource: 'საქართველოს ეროვნული ბანკი',
    },
    newsletter: {
      title: 'იყავი კურსში',
      subtitle: 'მიიღე შეტყობინებები ახალი გამოფენების, ექსკლუზიური კოლექციებისა და გალერეის ღონისძიებების შესახებ.',
      placeholder: 'შეიყვანეთ ელ. ფოსტა',
      subscribe: 'გამოწერა',
      success: 'მოგესალმებით! თქვენ წარმატებით გამოიწერეთ.',
      alreadySubscribed: 'თქვენ უკვე გამოწერილი ხართ!',
      invalidEmail: 'გთხოვთ შეიყვანოთ სწორი ელ. ფოსტა',
    },
    legal: {
      cookiePolicy: 'ქუქი-ფაილების პოლიტიკა',
      privacyPolicy: 'კონფიდენციალურობის პოლიტიკა',
      termsConditions: 'წესები და პირობები',
      lastUpdated: 'ბოლო განახლება: იანვარი 2025',
      terms: {
        intro: 'ეს წესები და პირობები არეგულირებს გალერეა ფოტოატელიეს ვებსაიტისა და სერვისების გამოყენებას. ჩვენს ვებსაიტზე შესვლით თქვენ ეთანხმებით ამ პირობების შესრულებას.',
        useTitle: 'ვებსაიტის გამოყენება',
        useText: 'შეგიძლიათ ჩვენი ვებსაიტი გამოიყენოთ მხოლოდ კანონიერი მიზნებისთვის. არ შეიძლება ვებსაიტის ისეთი გამოყენება, რომელიც შეიძლება დააზიანოს, გამორთოს ან შეაფერხოს ვებსაიტი ან სხვა მომხმარებელთა გამოყენება.',
        purchaseTitle: 'შესყიდვები და შეკვეთები',
        purchaseText: 'ყველა შესყიდვა ჩვენი გალერეის მეშვეობით ექვემდებარება ხელმისაწვდომობას. ფასები ნაჩვენებია ლარში და დოლარში. გადახდა უნდა დასრულდეს ნამუშევრის მიწოდებამდე. ყველა გაყიდვა საბოლოოა, თუ სხვაგვარად არ არის მითითებული.',
        ipTitle: 'ინტელექტუალური საკუთრება',
        ipText: 'ვებსაიტზე განთავსებული ყველა კონტენტი, მათ შორის სურათები, ტექსტი, დიზაინი და ლოგოები, არის გალერეა ფოტოატელიეს ან მისი არტისტების საკუთრება და დაცულია საავტორო უფლებებით.',
        liabilityTitle: 'პასუხისმგებლობის შეზღუდვა',
        liabilityText: 'გალერეა ფოტოატელიე არ იქნება პასუხისმგებელი არაპირდაპირ, შემთხვევით ან თანმიმდევრულ ზიანზე, რომელიც გამოწვეულია ჩვენი ვებსაიტის ან სერვისების გამოყენებით.',
        changesTitle: 'პირობების ცვლილება',
        changesText: 'ჩვენ ვიტოვებთ უფლებას ნებისმიერ დროს შევცვალოთ ეს წესები და პირობები. ცვლილებები ძალაში შევა ამ გვერდზე გამოქვეყნებისთანავე.',
        contactTitle: 'დაგვიკავშირდით',
        contactText: 'წესებთან და პირობებთან დაკავშირებული კითხვებისთვის მოგვწერეთ: info@fotoatelier.ge ან ეწვიეთ გალერეა ფოტოატელიეს, რუსთაველის გამზირი 12, თბილისი.',
      },
      cookie: {
        intro: 'ეს პოლიტიკა განმარტავს, თუ როგორ იყენებს გალერეა ფოტოატელიე ქუქი-ფაილებს და მსგავს ტექნოლოგიებს ჩვენი ვებსაიტის მონახულებისას.',
        whatTitle: 'რა არის ქუქი-ფაილები',
        whatText: 'ქუქი-ფაილები არის მცირე ტექსტური ფაილები, რომლებიც ინახება თქვენს მოწყობილობაზე ვებსაიტის მონახულებისას. ისინი ეხმარება საიტს დაიმახსოვროს თქვენი პრეფერენციები და გააუმჯობესოს ბრაუზინგის გამოცდილება.',
        howTitle: 'როგორ ვიყენებთ ქუქი-ფაილებს',
        howText: 'ჩვენ ვიყენებთ ქუქი-ფაილებს თქვენი ენის პრეფერენციის დასამახსოვრებლად, თემის არჩევანის შესანახად, კალათის შიგთავსის შესანარჩუნებლად, ანგარიშში შესული მდგომარეობის შესანარჩუნებლად და ვებსაიტის გაუმჯობესებისთვის.',
        typesTitle: 'ქუქი-ფაილების ტიპები',
        typesText: 'აუცილებელი ქუქი-ფაილები საჭიროა ვებსაიტის გამართულად მუშაობისთვის. პრეფერენციის ქუქი-ფაილები ახსოვს თქვენი პარამეტრები. ანალიტიკური ქუქი-ფაილები გვეხმარება გავიგოთ, როგორ იყენებენ ვიზიტორები საიტს.',
        managingTitle: 'ქუქი-ფაილების მართვა',
        managingText: 'შეგიძლიათ მართოთ ქუქი-ფაილები ბრაუზერის პარამეტრების მეშვეობით. გაითვალისწინეთ, რომ აუცილებელი ქუქი-ფაილების გამორთვამ შეიძლება გავლენა მოახდინოს ვებსაიტის ფუნქციონალურობაზე.',
        contactTitle: 'კითხვები',
        contactText: 'ქუქი-ფაილებთან დაკავშირებული კითხვებისთვის დაგვიკავშირდით: info@fotoatelier.ge ან ეწვიეთ ჩვენს გალერეას რუსთაველის გამზირი 12, თბილისი.',
      },
      privacy: {
        intro: 'გალერეა ფოტოატელიე მოწოდებულია თქვენი კონფიდენციალურობის დაცვაზე. ეს პოლიტიკა განმარტავს, თუ როგორ ვაგროვებთ, ვიყენებთ და ვიცავთ თქვენს პირად ინფორმაციას.',
        collectTitle: 'რა ინფორმაციას ვაგროვებთ',
        collectText: 'ჩვენ ვაგროვებთ ინფორმაციას, რომელსაც პირდაპირ გვაწვდით: სახელი, ელ. ფოსტა, ტელეფონის ნომერი და მიტანის მისამართი ანგარიშის შექმნისას ან შეკვეთის განთავსებისას. ასევე ვაგროვებთ ბრაუზინგის მონაცემებს.',
        useTitle: 'როგორ ვიყენებთ ინფორმაციას',
        useText: 'ვიყენებთ თქვენს ინფორმაციას შეკვეთების დასამუშავებლად და მისაწოდებლად, შენაძენებისა და ანგარიშის შესახებ კომუნიკაციისთვის, სიახლეების გასაგზავნად და ჩვენი სერვისების გასაუმჯობესებლად.',
        protectionTitle: 'მონაცემთა დაცვა',
        protectionText: 'ჩვენ ვახორციელებთ შესაბამის ტექნიკურ და ორგანიზაციულ ზომებს თქვენი პერსონალური მონაცემების დასაცავად არაავტორიზებული წვდომის, შეცვლის ან განადგურებისგან.',
        rightsTitle: 'თქვენი უფლებები',
        rightsText: 'თქვენ გაქვთ უფლება შეხვიდეთ, შეასწოროთ ან წაშალოთ თქვენი პერსონალური მონაცემები. შეგიძლიათ პროფილის ინფორმაციის განახლება ანგარიშის პარამეტრებიდან. მონაცემების წაშლის მოთხოვნისთვის პირდაპირ დაგვიკავშირდით.',
        contactTitle: 'დაგვიკავშირდით',
        contactText: 'კონფიდენციალურობასთან დაკავშირებული კითხვებისთვის მოგვწერეთ: info@fotoatelier.ge ან ეწვიეთ გალერეა ფოტოატელიეს, რუსთაველის გამზირი 12, თბილისი.',
      },
    },
    news: {
      title: 'პრესა და სიახლეები',
      subtitle: 'უახლესი გალერეა ფოტოატელიედან',
      readMore: 'სრულად წაკითხვა',
      backToNews: 'სიახლეებში დაბრუნება',
      noArticles: 'სტატიები ჯერ არ არის',
      featured: 'გამორჩეული',
      publishedOn: 'გამოქვეყნდა',
    },
    common: {
      loading: 'იტვირთება...',
      error: 'რაღაც შეცდომა მოხდა',
      retry: 'თავიდან ცდა',
      currency: {
        USD: '$',
        GEL: '₾',
      },
    },
  },
} as const;

export type TranslationKeys = typeof translations.en;
